var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['transparent-button', 'action-link', _vm.variantClassName, _vm.disabledClassName],attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":() => _vm.$emit('click')}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }